var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.resourceFilePath,"download":_vm.resourceTitle,"title":_vm.resourceTitle}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.resourceFilePath))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }